<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FXem3r/tc-custom/9781504085755.jpg?1704717895419" alt="This image is the cover for the book Bengal Fire, The Inspector Prike Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bengal Fire, The Inspector Prike Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>An impending wedding and two fiancées lead to murder on the Indian subcontinent in this Golden Age mystery featuring British CID Insp. Leonidas Prike.</b><br/>  <br/> Unsavory press agent Harrison J. Hoyt gets word that his American fiancée is arriving in Calcutta—just in time for his wedding to someone else. To diffuse the situation, he turns to gold broker Lee Marvin. After all, Marvin owes him his life; it’s the least he could do. But as Marvin delivers the bad news, he finds himself enchanted by the resilient blonde . . .<br/>  <br/> Though Hoyt’s bachelor dinner goes off without a hitch, he soon disappears after slipping Marvin a mysterious package. And when he shows up at his wedding the next day, it’s as a corpse. The police surgeon suspects natural causes, but Inspector Prike and Marvin, who is convinced that Hoyt’s dirty dealings have finally brought the man down, think otherwise. But what Marvin took possession of the night before—a nine-jewel talisman—ensnares him in the same web of duplicity.<br/>  <br/> Hot on the case, Inspector Prike must untangle threads of blackmail, betrayal, and deception among Calcutta’s upper crust, including Marvin, both jilted fiancées, a Maharajah, a big-game hunter, a disreputable journalist, and a Hawaiian purveyor of cheap cotton goods. What started out as a love triangle reveals the cold-hearted treachery of a very clever killer . . .  <br/>  <br/><b>“An exceptionally well-written novel.” —<i>The </i><i>Glasgow Herald</i></b><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence G. Blochman
      </h2>
      
      <p class="authorDescription body article">Lawrence G. Blochman (1900&ndash;1975) was an Edgar Award&ndash;winning author of mystery novels, a prominent translator of international crime fiction, and served as the fourth president of the Mystery Writers of America. He died in New York City.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f87c2f6